export const GET_ORDINANCE_REVISION_EFFECTIVITY = 'GET_ORDINANCE_REVISION_EFFECTIVITY/get_ordinance_revision_effectivity';
export const GET_FORMDATA_ORDINANCE_REVISION = 'GET_FORMDATA_ORDINANCE_REVISION/get_formdata_ordinance_revision'
export const GET_FORMDATA_ORDINANCE_REVISION_DEFAULT = 'GET_FORMDATA_ORDINANCE_REVISION_DEFAULT/get_formdata_ordinance_revision_default'
export const GET_REPORTS = 'module_distribution/get_reports';
export const GET_REPORT_LIST = 'module_distribution/get_report';
export const GET_PREVIEW_LINK = 'module_distribution/get_preview_link';
export const LIST = 'bpls_report/list';
export const GET_REPORT_ACCESS = 'bpls_report/get_report_access';

// export const Reports_URI = '/api/v1/administrators/report_file_exports_download/{id}/preview';
export const BPLS_MODULE_TYPE = [
  // { label: 'E-Boss', value: 'T_BPLS'},
  { label: 'BPLS', value: 'BPLS'},
]

export const KIND_OF_OWNERSHIP = [
  { label: 'ALL', value: '' },
  { label: 'SOLE PROPRIETORSHIP', value: 'SOLE PROPRIETORSHIP' },
  { label: 'ONE PERSON CORPORATION', value: 'ONE PERSON CORPORATION' },
  { label: 'PARTNERSHIP', value: 'PARTNERSHIP' },
  { label: 'CORPORATION', value: 'CORPORATION' },
  { label: 'COOPERATIVE', value: 'COOPERATIVE' },
];

export const REGISTRATION_STATUS = [
  { label: 'ALL', value: '' },
  { label: 'SUCCESSFUL', value: 'SUCCESSFUL' },
  { label: 'PENDING', value: 'PENDING' }
]